export class TaskDifferenceParam {
  RoomId : number;
  RoomNumber: string;
  OldDailyTypeId? : number;
  OldCleaningTypeId? : number;
  NewCleaningTypeId? : number;
  FroDate: string;
}
